import { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  // Button,
  Offcanvas,
  Dropdown,
  Form,
  // FormControl,
  // OverlayTrigger,
  // Tooltip,
} from "react-bootstrap";
import "./sidebar.css";
import { Link } from "react-router-dom";
import { NAV_LINKS, URLS } from "utils/constants";
import {
  IconMenu2,
  IconMoon,
  // IconX,
  // IconLogout,
  // IconBell,
  // IconCalendarEvent,
  // IconReport,
  // IconMoneybag,
  // IconLayoutDashboardFilled,
  // IconUsers,
  // IconSettings2,
  // IconPlus,
  IconRefresh,
  IconSun,
} from "@tabler/icons-react";
import { useAuth } from "hooks/useAuth";
// import SearchInvoice from "./search-reservation";
// import NotificationBell from "./components/NotificationBell";
// import NotificationBellV2 from "./notif-v2/NotificationBell";
// import NotificationBellV3 from "./notif-v3/NotificationBell";
// import { BookingProviderV3 } from "contexts/v3/BookingContextV3";
// import { CreatePageButton } from "pages/transaksi/booking-v3/booking-page-v3";

// SidebarLink component
// const SidebarLink = ({ link, index }) => {
//   return (
//     <div className={`sidebar-section ${index !== 0 ? "mt-3" : ""}`}>
//       <Nav.Item>
//         <div className="section-title">{link.name}</div>
//         {link.child ? (
//           link.child.map((child, index) => (
//             <Link
//               key={index}
//               to={child.href}
//               className="nav-link d-flex align-items-center"
//             >
//               <span className="icon-circle">
//                 <child.icon />
//               </span>
//               <span className="ml-2">{child.name}</span>
//             </Link>
//           ))
//         ) : (
//           <Link to={link.href} className="nav-link d-flex align-items-center">
//             <span className="icon-circle">
//               <link.icon />
//             </span>
//             <span className="ml-2">{link.name}</span>
//           </Link>
//         )}
//       </Nav.Item>
//     </div>
//   );
// };

// Sidebar component
// const SidebarVold = ({ children }) => {
//   const [show, setShow] = useState(false);
//   const { logout, user } = useAuth();

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   const handleLogout = () => logout();

//   // Ambil role user
//   const userRole = user?.roles?.[0]?.name; // Ambil role pertama

//   // Daftar role yang diizinkan untuk melihat menu tertentu
//   // const allowedMenus = {
//   //   superadmin: ["Dashboard", "Transaksi", "Master Data", "Settings"],
//   //   admin: ["Dashboard", "Transaksi", "Master Data"],
//   //   user: ["Dashboard"],
//   // };

//   // Filter menu berdasarkan role
//   // const filteredLinks = NAV_LINKS.filter((link) =>
//   //   allowedMenus[userRole]?.includes(link.name)
//   // );

//   // Limitasi submenu Transaksi berdasarkan role
//   const transactionMenu = [
//     {
//       name: "Booking",
//       href: URLS.v1.BOOKINGV3,
//       icon: IconCalendarEvent,
//       roles: ["superadmin", "admin", "user"],
//     },
//     {
//       name: "Booking Report",
//       href: URLS.v1.BOOKINGREPORT,
//       icon: IconReport,
//       roles: ["superadmin"],
//     },
//     {
//       name: "Susuk Agent",
//       href: URLS.v1.KOMISIAGENT,
//       icon: IconMoneybag,
//       roles: ["superadmin", "admin"],
//     },
//   ];

//   // Filter submenu transaksi berdasarkan role
//   const filteredTransactionMenu = transactionMenu.filter((item) =>
//     item.roles.includes(userRole)
//   );

//   return (
//     <>
//       <Navbar
//         bg="white"
//         variant="dark"
//         className="px-3 d-flex justify-content-between align-items-center border-bottom-0"
//         style={{
//           boxShadow:
//             "0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px -1px rgba(0,0,0,.1)",
//         }}
//       >
//         <button className="btn border-0 shadow-none ps-0" onClick={handleShow}>
//           <IconMenu2 size={24} className="text-primary" />
//         </button>

//         <Form
//           className="d-flex ms-3 me-1 align-items-center"
//           style={{ flex: 1 }}
//         >
//           {/* judul kuber app reservation */}
//           <div className="d-flex align-items-center text-primary">
//             {/* <h2 className="m-0">Kuber App | Reservation</h2> */}
//             <KuberAppTitle />
//           </div>
//         </Form>
//         <NotificationBellV2 />
//         {/* | v1 <NotificationBell /> */}

//         <Nav className="d-flex align-items-center">
//           {/* Left border before the language dropdown */}
//           <div
//             style={{
//               borderLeft: "1px solid #ccc",
//               height: "40px",
//               margin: "0 10px",
//             }}
//           ></div>

//           <Dropdown className="p-0 mx-3">
//             <Dropdown.Toggle
//               variant="light"
//               id="dropdown-user"
//               className="d-flex align-items-center p-0"
//             >
//               <img
//                 src={user.avatar || "https://i.pravatar.cc/150?img=1"}
//                 alt={user.name}
//                 className="rounded-circle me-2"
//                 style={{ width: "30px", height: "30px" }}
//               />
//             </Dropdown.Toggle>

//             <Dropdown.Menu align="end">
//               <Dropdown.Item as={Link} to={URLS.v1.PROFILE}>
//                 Profile
//               </Dropdown.Item>
//               <Dropdown.Divider />
//               <Dropdown.Item as={Link} onClick={handleLogout}>
//                 Logout
//               </Dropdown.Item>
//             </Dropdown.Menu>
//           </Dropdown>
//         </Nav>
//       </Navbar>

//       <Offcanvas
//         show={show}
//         onHide={handleClose}
//         placement="start"
//         className="sidebar-canvas"
//       >
//         <Offcanvas.Header className="d-flex justify-content-between">
//           <div className="d-flex lh-1 text-reset p-0">
//             {/* <img src={user.avatar || 'https://via.placeholder.com/150x150.png?text=JD'} alt={user.name} className="rounded-circle" style={{ width: '30px', height: '30px' }} /> */}
//             <span
//               className="avatar rounded-circle"
//               style={{ width: "30px", height: "30px" }}
//             >
//               {user.name
//                 .split(" ")
//                 .map((word) => word[0])
//                 .slice(0, 2)
//                 .join("")
//                 .toUpperCase()}
//             </span>
//             <div className="d-block ps-2">
//               <div>{user?.name}</div>
//               <div className="mt-1 small text-secondary">{user?.email}</div>
//             </div>
//           </div>
//           <a href="#">
//             <IconX size={24} onClick={handleClose} className="text-primary" />
//           </a>
//         </Offcanvas.Header>

//         {/* <Offcanvas.Body>
//           <Nav className="flex-column">
//             {NAV_LINKS.map((link, index) => (
//               <SidebarLink key={index} link={link} index={index} />
//             ))}
//           </Nav>
//         </Offcanvas.Body> */}

//         {/* <Offcanvas.Body>
//           <Nav className="flex-column">
//             {filteredLinks.map((link, index) => (
//               <SidebarLink key={index} link={link} index={index} />
//             ))}
//           </Nav>
//         </Offcanvas.Body> */}
//         <Offcanvas.Body>
//           <Nav className="flex-column">
//             {/* Dashboard */}
//             <SidebarLink
//               link={{
//                 name: "Dashboard",
//                 href: URLS.v1.DASHBOARD,
//                 icon: IconLayoutDashboardFilled,
//               }}
//             />

//             {/* Transaksi */}
//             {filteredTransactionMenu.length > 0 && (
//               <div className="sidebar-section mt-3">
//                 <Nav.Item>
//                   <div className="section-title">Transaksi</div>
//                   {filteredTransactionMenu.map((child, idx) => (
//                     <Link
//                       key={idx}
//                       to={child.href}
//                       className="nav-link d-flex align-items-center"
//                     >
//                       <span className="icon-circle">
//                         <child.icon />
//                       </span>
//                       <span className="ml-2">{child.name}</span>
//                     </Link>
//                   ))}
//                 </Nav.Item>
//               </div>
//             )}

//             {/* Master Data */}
//             <SidebarLink
//               link={{
//                 name: "Master Data",
//                 href: URLS.v1.CUSTOMERS,
//                 icon: IconUsers,
//               }}
//             />

//             {/* Attendance */}
//             <SidebarLink
//               link={{
//                 name: "Attendance",
//                 href: "/attendance-check",
//                 icon: IconCalendarEvent,
//               }}
//             />

//             {/* Settings */}
//             {userRole === "superadmin" && (
//               <SidebarLink
//                 link={{
//                   name: "Settings",
//                   href: URLS.v1.SYSTEM_SETTING,
//                   icon: IconSettings2,
//                 }}
//               />
//             )}
//           </Nav>
//         </Offcanvas.Body>
//       </Offcanvas>

//       <main>{children}</main>
//     </>
//   );
// };

const Sidebar = ({ children }) => {
  const [show, setShow] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem("kuber-dark-mode") === "1";
  });
  const { logout, user } = useAuth();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleLogout = () => logout();

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.body.classList.toggle("kuber-dark-mode", isDarkMode);
    document.documentElement.classList.toggle("kuber-dark-mode", isDarkMode);
    window.localStorage.setItem("kuber-dark-mode", isDarkMode ? "1" : "0");
  }, [isDarkMode]);

  // const userRole = user?.roles?.[0]?.name; // Ambil role pertama
  // const userRoles = user?.roles?.map((role) => role.name) || []; // Ambil semua role dalam array

  // Filter menu utama berdasarkan role
  // const filteredLinks = NAV_LINKS.filter((link) => link.roles.includes(userRoles));

  // V1
  // Ambil semua role user sebagai array
  const userRoles = user?.roles?.map((role) => role.name) || [];
  // Fungsi untuk cek apakah user punya akses ke menu
  const hasAccess = (allowedRoles) => {
    return userRoles.some((role) => allowedRoles.includes(role));
  };
  // Filter menu utama berdasarkan role user
  const filteredLinks = NAV_LINKS.filter((link) => hasAccess(link.roles || []));

  // V2
  // Ambil semua permission user sebagai array of string
  // const userPermissions =
  //   user?.permissions?.map((permission) => permission.name) || [];
  // console.log("userPermissions", userPermissions);
  // // Ambil semua role user sebagai array of string
  // const userRoles = user?.roles?.map((role) => role.name) || [];
  // // Fungsi untuk cek apakah user punya akses berdasarkan permission atau role
  // console.log("userRoles", userRoles);
  // const hasAccess = (allowedPermissions = [], allowedRoles = []) => {
  //   // Cek apakah ada permission yang diizinkan
  //   const hasPermission =
  //     allowedPermissions.length === 0 ||
  //     allowedPermissions.some((perm) => userPermissions.includes(perm));
  //   // Cek apakah ada role yang diizinkan
  //   const hasRole =
  //     allowedRoles.length === 0 ||
  //     allowedRoles.some((role) => userRoles.includes(role));
  //   // Akses diberikan jika salah satu (permission atau role) atau keduanya valid
  //   return hasPermission || hasRole;
  // };
  // // Filter menu berdasarkan permission dan/atau role
  // // const filteredLinks = NAV_LINKS.filter((link) =>
  // //   hasAccess(link.permissions, link.roles)
  // // );
  // const filteredLinks = NAV_LINKS
  // .filter((link) => hasAccess(link.permissions, link.roles)) // ini penting!
  // .map((link) => ({
  //   ...link,
  //   child: link.child?.filter((child) =>
  //     hasAccess(child.permissions, child.roles)
  //   ),
  // }));

  return (
    <>
      <Navbar bg="white" variant="dark" className="px-3">
        <button className="btn border-0 shadow-none ps-0" onClick={handleShow}>
          <IconMenu2 size={24} className="text-primary" />
        </button>

        <Form
          className="d-flex ms-3 me-1 align-items-center"
          style={{ flex: 1 }}
        >
          {/* judul kuber app reservation */}
          <div className="d-flex align-items-center text-primary">
            {/* <h2 className="m-0">Kuber App | Reservation</h2> */}
            <KuberAppTitle />
          </div>
        </Form>
        {/* <div className="relative d-inline-block">
          <button
            className="btn btn-outline-primary me-2 position-relative"
            aria-label="Show notifications"
          >
            <IconPlus size={24} />
          </button>
        </div> */}

        {/* IconPlushCreatePage */}
        {/* <CreatePageButton/> */}
        {/* Tombol Refresh PWA */}
        <button
          className="btn btn-outline-primary me-2"
          style={{ border: "none", background: "none" }}
          title="Refresh PWA"
          onClick={() => {
            if (
              window.AndroidPrintHandler &&
              typeof window.AndroidPrintHandler.refreshPwa === "function"
            ) {
              window.AndroidPrintHandler.refreshPwa();
            } else {
              window.location.reload();
            }
          }}
        >
          <IconRefresh size={22} />
        </button>
        <button
          className="btn btn-outline-primary me-2 d-inline-flex align-items-center gap-1 kuber-dark-toggle"
          title={isDarkMode ? "Gunakan mode terang" : "Gunakan dark mode"}
          onClick={() => setIsDarkMode((prev) => !prev)}
        >
          {isDarkMode ? <IconSun size={18} /> : <IconMoon size={18} />}
          <span className="d-none d-md-inline small fw-semibold">
            {isDarkMode ? "Light" : "Dark"}
          </span>
        </button>
        {/* {["superadmin", "admin", "reservation"].some((role) =>
          userRoles.includes(role)
        ) && <NotificationBellV3 />} */}

        {/* <NotificationBellV3 /> */}
        {/* <NotificationBellV2 /> */}
        {/* | v1 <NotificationBell /> */}

        <Nav className="d-flex align-items-center">
          {/* Left border before the language dropdown */}
          <div
            style={{
              borderLeft: "1px solid #ccc",
              height: "40px",
              margin: "0 10px",
            }}
          ></div>

          <Dropdown className="p-0 mx-3">
            <Dropdown.Toggle
              variant="light"
              id="dropdown-user"
              className="d-flex align-items-center p-0"
            >
              <img
                src={user.avatar || "https://i.pravatar.cc/150?img=1"}
                alt={user.name}
                className="rounded-circle me-2"
                style={{ width: "30px", height: "30px" }}
              />
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              <Dropdown.Item as={Link} to={URLS.v1.PROFILE}>
                Profile
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={URLS.v1.PENGATURAN_APLIKASI}>
                APP Settings
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item as={Link} onClick={handleLogout}>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Navbar>

      <Offcanvas show={show} onHide={handleClose} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{user?.name}</Offcanvas.Title>
        </Offcanvas.Header>
        {/* <Offcanvas.Body>
          <Nav className="flex-column">
            {filteredLinks.map((link, index) => (
              <div key={index} className={`sidebar-section ${index !== 0 ? "mt-3" : ""}`}>
                <Nav.Item>
                  <div className="section-title">{link.name}</div>
                  {link.child ? (
                    link.child
                      .filter((child) => child.roles.includes(userRoles)) // Filter submenu berdasarkan role
                      .map((child, idx) => (
                        <Link key={idx} to={child.href} className="nav-link d-flex align-items-center">
                          <span className="icon-circle">
                            <child.icon />
                          </span>
                          <span className="ml-2">{child.name}</span>
                        </Link>
                      ))
                  ) : (
                    <Link to={link.href} className="nav-link d-flex align-items-center">
                      <span className="icon-circle">
                        <link.icon />
                      </span>
                      <span className="ml-2">{link.name}</span>
                    </Link>
                  )}
                </Nav.Item>
              </div>
            ))}
          </Nav>
        </Offcanvas.Body> */}
        <Offcanvas.Body>
          <Nav className="flex-column">
            {filteredLinks.map((link, index) => (
              <div
                key={index}
                className={`sidebar-section ${index !== 0 ? "mt-3" : ""}`}
              >
                <Nav.Item>
                  <div className="section-title">{link.name}</div>
                  {link.child ? (
                    link.child
                      .filter((child) => hasAccess(child.roles || [])) // Filter submenu berdasarkan role
                      .map((child, idx) => (
                        <Link
                          key={idx}
                          to={child.href}
                          className="nav-link d-flex align-items-center"
                        >
                          <span className="icon-circle">
                            <child.icon />
                          </span>
                          <span className="ml-2">{child.name}</span>
                        </Link>
                      ))
                  ) : (
                    <Link
                      to={link.href}
                      className="nav-link d-flex align-items-center"
                    >
                      <span className="icon-circle">
                        <link.icon />
                      </span>
                      <span className="ml-2">{link.name}</span>
                    </Link>
                  )}
                </Nav.Item>
              </div>
            ))}

            {/* Attendance Menu - Available for all logged-in users */}
            {/* <div className="sidebar-section mt-3">
              <Nav.Item>
                <div className="section-title">Attendance</div>
                <Link
                  to="/attendance-check"
                  className="nav-link d-flex align-items-center"
                >
                  <span className="icon-circle">
                    <IconCalendarEvent />
                  </span>
                  <span className="ml-2">Check Attendance</span>
                </Link>
              </Nav.Item>
            </div> */}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

      <main>{children}</main>
    </>
  );
};

export default Sidebar;

const KuberAppTitle = () => {
  return (
    <h2 className="m-0">
      <span style={{ color: "#877453" }}>K</span>
      <span style={{ color: "#877453" }}>U</span>
      <span style={{ color: "#877453" }}>B</span>
      <span style={{ color: "#877453" }}>E</span>
      <span style={{ color: "#877453" }}>R</span>
      <span style={{ color: "#3c4234" }}> App</span>
    </h2>
  );
};
